import { NavigationGuardNext, Route } from 'vue-router'

import store from '@/store'

function fetchSubscriptionGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  store.dispatch('subscription/FETCH_SUBSCRIPTION_DETAILS').finally(() => next())
}

export default fetchSubscriptionGuard
